import { useIntl } from 'react-intl';
import DialogTitle from '@rossum/components/dialog-title/DialogTitle';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@rossum/ui/material';
import { boldText, white } from '../../../lib/formaterValues';

export type ToggleAllDialogAction =
  | 'disableAllQueues'
  | 'addAllQueues'
  | undefined;

type ToggleAllDialogProps = {
  action: ToggleAllDialogAction;
  workspaceName: string;
  onClose: () => void;
  onSubmit: () => void;
};
export const ToggleAccessToAllQueuesDialog = ({
  action,
  workspaceName,
  onClose,
  onSubmit,
}: ToggleAllDialogProps) => {
  const intl = useIntl();

  return (
    <Dialog
      open={!!action}
      PaperProps={{
        sx: { width: 480, minHeight: 220, position: 'fixed' },
        elevation: 2,
      }}
      onClose={onClose}
      sx={{ transition: 'smooth' }}
    >
      {action ? (
        <Stack>
          <DialogTitle
            title={intl.formatMessage({
              id: `components.modal.${action}.title`,
            })}
            onClose={onClose}
          />
          <DialogContent sx={{ mx: 4, mt: 4, p: 0 }}>
            <Typography variant="body1">
              {intl.formatMessage(
                {
                  id: `components.modal.${action}.text`,
                },
                { bold: boldText, white, workspaceName }
              )}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ pb: 4, pt: 2.5, mr: 4, pr: 0 }}>
            <Button
              variant="outlined"
              size="medium"
              color="secondary"
              onClick={onClose}
              data-cy="modal-cancel-button"
            >
              {intl.formatMessage({
                id: `components.modal.${action}.cancel`,
              })}
            </Button>
            <Button
              variant="contained"
              size="medium"
              color="primary"
              onClick={onSubmit}
              data-cy="modal-confirm-button"
            >
              {intl.formatMessage({
                id: `components.modal.${action}.confirm`,
              })}
            </Button>
          </DialogActions>
        </Stack>
      ) : null}
    </Dialog>
  );
};
